export function isEmpty(str) {
    if (str == null) {
        return true;
    }
    if (str.length == 0) {
        return true;
    }
}

export function dateFormat(fmt, date) { //author: meizz
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export function checkEmail(email) {
    return RegExp(/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/).test(
        email);
}

//校验手机格式
export function checkMobile(s) {
    return /^1[0-9]{10}$/.test(s)
}


export function getFileExtName(filename) {
    if (!filename || typeof filename !== 'string') {
        return false
    }
    let a = filename.split('').reverse().join('')
    let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
    return b.toLowerCase()
}

export function formatDate(time, fmt) {
    var o = {
        'M+': time.getMonth() + 1, //月份
        'd+': time.getDate(), //日
        'h+': time.getHours(), //小时
        'm+': time.getMinutes(), //分
        's+': time.getSeconds(), //秒
        'q+': Math.floor((time.getMonth() + 3) / 3), //季度
        S: time.getMilliseconds() //毫秒
    }
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (time.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
    for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ?
                    o[k] :
                    ('00' + o[k]).substr(('' + o[k]).length)
            )
    return fmt
}

//base64转Blob
export function base64toFile(dataurl, filename = 'file') {

    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let suffix = mime.split('/')[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
    })
}

// 加密函数
export function encrypt(phone, code, timestamp) {
    // 拼接参数
    const rawData = `phone=${phone}&code=${code}&ts=${timestamp}`;

    // Base64 编码
    const base64 = btoa(rawData);

    // 字符替换（自定义规则）
    const replaced = base64
        .replace(/=/g, '@')
        .replace(/\+/g, '$')
        .replace(/\//g, '!');

    // 反转字符串
    return replaced.split('').reverse().join('');
}

// 加密函数
export function encryptBosObjectKey(objectKey, timestamp) {
    // 拼接参数
    const rawData = `objectKey=${objectKey}&ts=${timestamp}`;

    // Base64 编码
    const base64 = btoa(rawData);

    // 字符替换（自定义规则）
    const replaced = base64
        .replace(/=/g, '@')
        .replace(/\+/g, '$')
        .replace(/\//g, '!');

    // 反转字符串
    return replaced.split('').reverse().join('');
}

export default {
    getFileExtName,
    formatDate,
    checkMobile,
    base64toFile,
    encrypt
}
